import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSmileySelectedEmojiSecondary from './svgs/SmileySelectedEmojiSecondary.js';
import SvgSmileySelectedEmoji from './svgs/SmileySelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var smileySelectedEmoji = (props => useIcon(SvgSmileySelectedEmoji, SvgSmileySelectedEmojiSecondary, props));

export { smileySelectedEmoji as default };
